import { VeltUserInviteTool } from '@veltdev/react';
import React from 'react'
import './UserInviteToolPage.css';

function UserInviteToolPage() {
    return (
        <div id="userInviteToolContainer">
            <div className="user-invite-tool-main-view">
                <p className="boujeeText">Click on the button below to share project.</p>
                <div className='user-invite-tools-container'>
                    <VeltUserInviteTool />
                </div>
            </div>
        </div>
    )
}

export default UserInviteToolPage;